import { compose, map, sortBy } from 'lodash/fp';
import { createSelector } from 'reselect';
import { createOptionsSelector } from '@mews-commander/utils';
import { Language } from '@mews-commander/data-access';
import { getLanguages as getLanguagesSelector } from '@mews-commander/core/legacy-globalization';

export const getSortedLanguages = createSelector(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    getLanguagesSelector,
    (languages: Array<Language>): Array<Language> => sortBy('name', languages)
);

export const getLanguages = createSelector(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    getLanguagesSelector,
    compose(
        sortBy('name'),
        map((l) => ({ id: (l as $TSFixMe).code, name: (l as $TSFixMe).englishName }))
    )
);

export const getLanguageCodes = createSelector(getLanguagesSelector, map('code'));

export const getLanguageOptions = createOptionsSelector(getLanguages);
